const baseGrayHue = 0;
const baseGraySaturation = '0%';

const baseRedHue = 0;
const baseRedSaturation = '62%';
const darkRedSaturation = '98%';

const baseOrangeHue = 8;
const baseOrangeSaturation = '97%';
const darkOrangeSaturation = '46%';

const baseYellowHue = 45;
const baseYellowSaturation = '95%';
const darkYellowSaturation = '59%';

const baseGreenHue = 168;
const baseGreenSaturation = '36%';
const darkGreenSaturation = '69%';

const baseBlueGreenHue = 195;
const baseBlueGreenSaturation = '47%';
const darkBlueGreenSaturation = '69%';

const baseBlueHue = 205;
const mediumBlueHue = 233;
const baseBlueSaturation = '62%';
const mediumBlueSaturation = '41%';
const darkBlueSaturation = '100%';

const basePurpleHue = 263;
const basePurpleSaturation = '50%';

const baseLightRedHue = 342;
const baseLightRedSaturation = '57%';

export const black = `hsl(${baseGrayHue}, ${baseGraySaturation}, 0%)`;

export const grays = [
  `hsl(${baseGrayHue}, ${baseGraySaturation}, 100%)`,
  `hsl(${baseGrayHue}, ${baseGraySaturation}, 85.8%)`,
  `hsl(${baseGrayHue}, ${baseGraySaturation}, 71.5%)`,
  `hsl(${baseGrayHue}, ${baseGraySaturation}, 57.2%)`,
  `hsl(${baseGrayHue}, ${baseGraySaturation}, 42.9%)`,
  `hsl(${baseGrayHue}, ${baseGraySaturation}, 28.6%)`,
  `hsl(${baseGrayHue}, ${baseGraySaturation}, 14.3%)`,
  black,
];

export const reds = [
  `hsl(${baseRedHue}, ${baseRedSaturation}, 94%)`,
  `hsl(${baseRedHue}, ${baseRedSaturation}, 82%)`,
  `hsl(${baseRedHue}, ${baseRedSaturation}, 69%)`,
  `hsl(${baseRedHue}, ${baseRedSaturation}, 57%)`,
  `hsl(${baseRedHue}, ${darkRedSaturation}, 38%)`,
  `hsl(${baseRedHue}, ${darkRedSaturation}, 27%)`,
];

export const oranges = [
  `hsl(${baseOrangeHue}, ${baseOrangeSaturation}, 97%)`,
  `hsl(${baseOrangeHue}, ${baseOrangeSaturation}, 90%)`,
  `hsl(${baseOrangeHue}, ${baseOrangeSaturation}, 84%)`,
  `hsl(${baseOrangeHue}, ${baseOrangeSaturation}, 77%)`,
  `hsl(${baseOrangeHue}, ${baseOrangeSaturation}, 66%)`,
  `hsl(${baseOrangeHue}, ${darkOrangeSaturation}, 40%)`,
];

export const yellows = [
  `hsl(${baseYellowHue}, ${baseYellowSaturation}, 90%)`,
  `hsl(${baseYellowHue}, ${baseYellowSaturation}, 88%)`,
  `hsl(${baseYellowHue}, ${baseYellowSaturation}, 81%)`,
  `hsl(${baseYellowHue}, ${baseYellowSaturation}, 73%)`,
  `hsl(${baseYellowHue}, ${baseYellowSaturation}, 61%)`,
  `hsl(${baseYellowHue}, ${darkYellowSaturation}, 37%)`,
];

export const greens = [
  `hsl(${baseGreenHue}, ${baseGreenSaturation}, 93%)`,
  `hsl(${baseGreenHue}, ${baseGreenSaturation}, 78%)`,
  `hsl(${baseGreenHue}, ${baseGreenSaturation}, 63%)`,
  `hsl(${baseGreenHue}, ${baseGreenSaturation}, 48%)`,
  `hsl(${baseGreenHue}, ${darkGreenSaturation}, 34%)`,
  `hsl(${baseGreenHue}, ${darkGreenSaturation}, 20%)`,
];

export const blueGreens = [
  `hsl(${baseBlueGreenHue}, ${baseBlueGreenSaturation}, 94%)`,
  `hsl(${baseBlueGreenHue}, ${baseBlueGreenSaturation}, 82%)`,
  `hsl(${baseBlueGreenHue}, ${baseBlueGreenSaturation}, 71%)`,
  `hsl(${baseBlueGreenHue}, ${baseBlueGreenSaturation}, 59%)`,
  `hsl(${baseBlueGreenHue}, ${darkBlueGreenSaturation}, 41%)`,
  `hsl(${baseBlueGreenHue}, ${darkBlueGreenSaturation}, 29%)`,
];

export const blues = [
  `hsl(${baseBlueHue}, ${baseBlueSaturation}, 95%)`,
  `hsl(${baseBlueHue}, ${baseBlueSaturation}, 84%)`,
  `hsl(${baseBlueHue}, ${baseBlueSaturation}, 69%)`,
  `hsl(${baseBlueHue}, ${baseBlueSaturation}, 57%)`,
  `hsl(${mediumBlueHue}, ${mediumBlueSaturation}, 38%)`,
  `hsl(${baseBlueHue}, ${darkBlueSaturation}, 23%)`,
];

export const purples = [
  `hsl(${basePurpleHue}, ${basePurpleSaturation}, 95%)`,
  `hsl(${basePurpleHue}, ${basePurpleSaturation}, 84%)`,
  `hsl(${basePurpleHue}, ${basePurpleSaturation}, 74%)`,
  `hsl(${basePurpleHue}, ${basePurpleSaturation}, 63%)`,
  `hsl(${basePurpleHue}, ${basePurpleSaturation}, 47%)`,
  `hsl(${basePurpleHue}, ${basePurpleSaturation}, 33%)`,
];

export const lightReds = [
  `hsl(${baseLightRedHue}, ${baseLightRedSaturation}, 95%)`,
  `hsl(${baseLightRedHue}, ${baseLightRedSaturation}, 86%)`,
  `hsl(${baseLightRedHue}, ${baseLightRedSaturation}, 76%)`,
  `hsl(${baseLightRedHue}, ${baseLightRedSaturation}, 67%)`,
  `hsl(${baseLightRedHue}, ${baseLightRedSaturation}, 52%)`,
  `hsl(${baseLightRedHue}, ${baseLightRedSaturation}, 36%)`,
];

export type ColorPaletteKey =
  | 'blues'
  | 'blueGreens'
  | 'grays'
  | 'greens'
  | 'purples'
  | 'oranges'
  | 'reds'
  | 'lightReds'
  | 'yellows';

export const defaultColorOrder: ColorPaletteKey[] = [
  'reds',
  'oranges',
  'yellows',
  'greens',
  'blueGreens',
  'blues',
  'purples',
  'lightReds',
];

export const colorMap: Record<ColorPaletteKey, string[]> = {
  blueGreens,
  blues,
  grays,
  greens,
  lightReds,
  oranges,
  purples,
  reds,
  yellows,
};

export const defaultColorPalette: string[][] = defaultColorOrder.reduce(
  (columns: string[][], colorKey: ColorPaletteKey, index: number): string[][] => {
    const colorColumn = colorMap[colorKey];
    colorColumn.splice(0, 0, grays[index]);
    columns.push(colorColumn);
    return columns;
  },
  []
);
